<template>
  <div
    v-on-clickaway="close"
    :class="{ 'cursor-pointer': !isEditOpen && !disabled }"
    :data-test="dataTest"
    @click="edit()"
  >
    <div v-if="unsaved && isEditOpen" class="dimness" @click.stop="close"></div>
    <slot :isEdit="isEditOpen" :isRead="!isEditOpen"></slot>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'

export default {
  inheritAttrs: false,
  mixins: [ clickaway ],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    unsaved: {
      type: Boolean,
      default: false,
    },
    dataTest: {
      type: String,
      default: '',
    },
  },
  data: () => ({ isEditOpen: false }),
  methods: {
    edit () {
      if (!this.isEditOpen && !this.disabled) {
        this.$emit('edit', this.value)
        this.isEditOpen = true
      }
    },
    close () {
      if (this.isEditOpen && !this.disabled) {
        this.$emit('close')
        this.isEditOpen = false
      }
    },
  },
}
</script>

<style scoped>
  .dimness {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
  }
</style>
